import UserDataPage from './UserDataPage';

export default UserDataPage;
